import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  shiftManagement: {
    // Holt den Tagesplan + Tasks + Notizen
    fetchHistory(user) {
      let url = buildUrl(`appointments/history/${user}`)
      return axios.get(url, buildOptions())
    },
    fetchDailyView(dateStr) {
      let url = buildUrl(`studio-operation/daily-view/${dateStr}`)
      return axios.get(url, buildOptions())
    },
    fetchWeeklyView(startDate) {
      let url = buildUrl(`studio-operation/weekly-view/${startDate}`)
      return axios.get(url, buildOptions())
    },

    // TASKS (Ämtli)
    createTask(data) {
      // data: { date, time, title, description, assignedEmployee, ... }
      let url = buildUrl("studio-operation/task")
      return axios.post(url, data, buildOptions())
    },
    updateTask(id, data) {
      let url = buildUrl(`studio-operation/task/${id}`)
      return axios.put(url, data, buildOptions())
    },
    deleteTask(id, scope = "single") {
      let url = buildUrl(`studio-operation/task/${id}?scope=${scope}`)
      return axios.delete(url, buildOptions())
    },
    autoAssignTasks(data) {
      let url = buildUrl("studio-operation/auto-assign-tasks")
      return axios.post(url, data, buildOptions())
    },
    createTemplate(data) {
      let url = buildUrl("studio-operation/template")
      return axios.post(url, data, buildOptions())
    },
    deleteTemplate(id) {
      let url = buildUrl(`studio-operation/template/${id}`)
      return axios.delete(url, buildOptions())
    },
    updateTemplate(id, data) {
      let url = buildUrl(`studio-operation/template/${id}`)
      return axios.put(url, data, buildOptions())
    },
    markTemplateAsDone(data) {
      let url = buildUrl("studio-operation/template-completion")
      return axios.post(url, data, buildOptions())
    },
    removeTemplateDone(id) {
      let url = buildUrl(`studio-operation/template-completion/${id}`)
      return axios.delete(url, buildOptions())
    },

    // APPOINTMENTS
    createAppointment(data) {
      let url = buildUrl("studio-operation/appointment")
      return axios.post(url, data, buildOptions())
    },
    updateAppointment(id, data) {
      let url = buildUrl(`studio-operation/appointment/${id}`)
      return axios.put(url, data, buildOptions())
    },
    deleteAppointment(id, reason, scope = "single") {
      let url = buildUrl(`studio-operation/appointment/${id}`)
      return axios.put(url, { deleted: true, deleteReason: reason || "", scope }, buildOptions())
    },

    // NOTES (Tages-Notizen)
    createNote(data) {
      // data: { date, targetEmployee, content }
      let url = buildUrl("studio-operation/note")
      return axios.post(url, data, buildOptions())
    },
    deleteNote(id) {
      let url = buildUrl(`studio-operation/note/${id}`)
      return axios.delete(url, buildOptions())
    },
    // api.shiftManagement.fetchPlan(studioId, start, end) -> { shifts: [...] }
    fetchPlan(studioId, startDate, endDate) {
      let url = buildUrl(`shift-management/plan/fetch/${studioId}/${startDate}/${endDate}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    fetchNotes(studioId, startDate, endDate) {
      let url = buildUrl(`shift-management/plan/notes/${studioId}/${startDate}/${endDate}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    generateFromTemplate(studioId, startDate, endDate) {
      let url = buildUrl("plan/generate-from-template")
      return axios.post(url, { studio: studioId, startDate, endDate }, buildOptions()).then((res) => res.data)
    },
    assignEmployeesToPlan(studioId, startDate, endDate, planningSettings, confirmedEmployeeUserIds, planningStrategy = "rotation") {
      let url = buildUrl("shift-management/plan/assign-employees")
      const payload = { studio: studioId, startDate, endDate, planningSettings, confirmedEmployeeUserIds, planningStrategy }
      return axios.post(url, payload, buildOptions()).then((res) => res.data)
    },
    resetPlanAssignments(studioId, startDate, endDate) {
      let url = buildUrl("shift-management/plan/reset")
      const payload = { studio: studioId, startDate, endDate }
      return axios.post(url, payload, buildOptions()).then((res) => res.data)
    },
    deleteUnassignedShifts(studioId, startDate, endDate) {
      let url = buildUrl("shift-management/plan/delete-unassigned")
      const payload = { studio: studioId, startDate, endDate }
      return axios.post(url, payload, buildOptions()).then((res) => res.data)
    },
    updateStudioOffset(studioId, offset) {
      let url = buildUrl("shift-management/studio/offset")
      return axios.put(url, { studioId, offset }, buildOptions()).then((res) => res.data)
    },
    createSpecialDay(data) {
      let url = buildUrl("shift-management/plan/special-day")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    deleteSpecialDay(studioId, date) {
      let url = buildUrl("shift-management/plan/special-day/" + studioId + "/" + date)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
    createManualShift(data) {
      let url = buildUrl("shift-management/shift")
      return axios.post(url, data, buildOptions())
    },

    updateShift(shiftId, data) {
      let url = buildUrl(`shift-management/shift/${shiftId}`)
      return axios.put(url, data, buildOptions())
    },
    fetchCandidates(shiftId, planningStrategy = "rotation") {
      let url = buildUrl(`shift-management/shift/${shiftId}/candidates?planningStrategy=${planningStrategy}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    // 3. SCHICHT LÖSCHEN
    deleteShift(shiftId) {
      let url = buildUrl(`shift-management/shift/${shiftId}`)
      return axios.delete(url, buildOptions())
    },
    generatePlanFromTemplate(studioId, startDate, endDate) {
      let url = buildUrl("plan/generate-from-template")
      const payload = { studio: studioId, startDate, endDate }
      return axios.post(url, payload, buildOptions()).then((res) => res.data)
    },
    fetchWeeklyTemplate(studioId) {
      let url = buildUrl(`shift-management/template/weekly/${studioId}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    saveWeeklyTemplate(studioId, templateData) {
      let url = buildUrl(`shift-management/template/weekly/${studioId}`)
      return axios.put(url, { template: templateData }, buildOptions()).then((res) => res.data)
    },
    fetchSettings(studioId) {
      let url = buildUrl("shift-management/settings/fetch/" + studioId)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    saveEmployeeSortOrder(employeeIds) {
      let url = buildUrl("shift-management/employee/sort-order")
      return axios.put(url, { employeeIds }, buildOptions()).then((res) => res.data)
    },
    updateEmployeePlanningSettings(employeeId, settings) {
      let url = buildUrl(`employee/website/planning-settings/${employeeId}`)
      return axios.put(url, settings, buildOptions()).then((res) => res.data)
    },
    createOrUpdateSettings(data) {
      let url = buildUrl("shift-management/settings/create-or-update")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    deleteSetting(type, id) {
      let url = buildUrl(`shift-management/settings/delete/${type}/${id}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },

    fetchShiftManagementCheckinData() {
      let url = buildUrl("shift-management/checkin/data")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    fetchAllHolidayEntries() {
      let url = buildUrl("timetracker/holidays/all")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    fetchShiftManagementEmployee(studioId) {
      let url = buildUrl("shift-management/employee/data" + (studioId ? `/${studioId}` : ""))
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    createShiftPlanEntry(data) {
      let url = buildUrl("shift-management/plan/create")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },

    fetchShiftPlans(studioId, startDate, endDate) {
      let url = buildUrl(`shift-management/plan/fetch/${studioId}/${startDate}/${endDate}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    fetchPlansOverview(studioId) {
      let url = buildUrl(`shift-management/plans/overview/${studioId}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    deleteShiftPlanEntry(id) {
      let url = buildUrl(`shift-management/plan/delete/${id}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },

    // *** NEU: FEIERTAGE ***
    fetchPublicHolidays(studioId, startDate, endDate) {
      let url = buildUrl(`shift-management/public-holidays/${studioId}/${startDate}/${endDate}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    // *** NEU: PLANNING SETTINGS (ersetzt localStorage) ***
    savePlanningSettings(employeeId, studioId, settings) {
      let url = buildUrl(`shift-management/planning-settings/${employeeId}/${studioId}`)
      return axios.put(url, settings, buildOptions()).then((res) => res.data)
    },
    loadPlanningSettings(employeeId, studioId) {
      let url = buildUrl(`shift-management/planning-settings/${employeeId}/${studioId}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    // *** NEU: VORMONATS-KONTEXT ***
    fetchPreviousMonthContext(studioId, monthStartDate) {
      let url = buildUrl(`shift-management/plan/previous-context/${studioId}/${monthStartDate}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    // *** NEU: EMPLOYEE PLANNING VIEW ***
    fetchEmployeeScheduleDaily(dateStr) {
      let url = buildUrl(`shift-management/employee-schedule/daily/${dateStr}`)
      return axios
        .get(url, buildOptions())
        .then((res) => res.data)
        .catch(() => null)
    },
    fetchEmployeeScheduleMonthly(monthStr) {
      let url = buildUrl(`shift-management/employee-schedule/monthly/${monthStr}`)
      return axios
        .get(url, buildOptions())
        .then((res) => res.data)
        .catch(() => null)
    },
    downloadEmployeeSchedule(monthStr) {
      let url = buildUrl(`shift-management/employee-schedule/download/${monthStr}`)
      return axios
        .get(url, { ...buildOptions(), responseType: "blob" })
        .then((res) => res.data)
        .catch(() => null)
    },

    // WORKCALENDAR STATISTIK DASHBOARD
    fetchWorkCalendarStatistics(data) {
      // data: { studios: [id, ...], range: ["YYYY-MM-DD", "YYYY-MM-DD"] }
      let url = buildUrl("studio-operation/statistics")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    createSickFromTransfer(data) {
      // data: { employee, date }
      let url = buildUrl("shift-management/sick/create-from-transfer")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    fetchSeriesPreview(data) {
      let url = buildUrl("studio-operation/series-preview")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    batchCreateSeries(data) {
      let url = buildUrl("studio-operation/batch-create")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    fetchActiveSeries() {
      let url = buildUrl("studio-operation/active-series")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    fetchTasksDashboard(startDate, endDate) {
      let url = buildUrl(`studio-operation/tasks-dashboard/${startDate}/${endDate}`)
      return axios.get(url, buildOptions())
    },
    publishTasks(data) {
      let url = buildUrl("studio-operation/tasks/publish")
      return axios.post(url, data, buildOptions())
    },
  },
}
